import style from './NavBar.module.scss';
import className from 'classnames/bind';
import {memo, useMemo} from "react";
import {NavBarData} from "./NavBarData";
import { Menu } from 'antd'
import {useLocation} from "react-router-dom";

const cn = className.bind(style);

function findActiveKey(navItems, pathname)
{
	const allItems = [];

	for (const item of navItems)
	{
		if (!item) continue; // tránh lỗi item null

		if (item.to)
		{
			allItems.push({ key: item.key, to: item.to });
		}

		// children
		if (Array.isArray(item.children))
		{
			for (const child of item.children)
			{
				if (child && child.to)
				{
					allItems.push({ key: child.key, to: child.to });
				}
			}
		}
	}

	// Nếu không có item nào → fallback
	if (allItems.length === 0) return "home";

	// Sort để ưu tiên route dài nhất (tránh "/" match tất cả)
	allItems.sort((a, b) => b.to.length - a.to.length);

	// Match từ dài -> ngắn
	for (const item of allItems)
	{
		if (pathname.startsWith(item.to))
		{
			return item.key;
		}
	}

	return "home";
}

function NavBar()
{
	const location = useLocation();

	const pathname = location.pathname;

	const navBarList = NavBarData();

	const moduleActive = useMemo(() => {
		return findActiveKey(navBarList, pathname);
	}, [pathname, navBarList]);

	return (
		<Menu
			className={cn('navbar')}
			mode="horizontal"
			selectedKeys={[moduleActive]}
			items={navBarList}
			style={{
				flex: 1,
				minWidth: 0,
				background: 'var(--primary)',
				borderBottom: 'none',
				justifyContent: 'center'
			}}
		/>
	);
}

export default memo(NavBar)